import { render, staticRenderFns } from "./editInstock.vue?vue&type=template&id=01aedbfe&scoped=true&"
import script from "./editInstock.vue?vue&type=script&lang=js&"
export * from "./editInstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aedbfe",
  null
  
)

export default component.exports